import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import MainLayout from "@/components/layout/admin/MainLayout.vue";
import store from '../../../store';
import axios from "axios";
import CONFIG from "@/assets/js/config.custom.js";
import {
    required,
    maxLength,
} from "vuelidate/lib/validators";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import Select2Multiple from "v-select2-multiple-component";

export default {
    name: "HolidayEdit",
    components: {
        MainLayout,
        flatPickr,
        Loading,
        Select2Multiple,
    },

    data() {
        return {
            isLoading: false,
            disabled: false,
            holidayData: {
                category_id: 1,
            },
            noDataMsg: CONFIG.NO_DATA_EXIST,
            submitted: false,
            typeArr: null,
            categoryArr: null,
            holidayTypeValid: true,
            holidayCategoryValid: true,
        };
    },
     watch: {
         'holidayData.type': {
             immediate: true,
             handler: function(newVal) {
                 if (Number(newVal) !== 3) {
                     this.holidayData.is_day_off = 1;
                 }
             }
         }
     },

    computed: {
        categorySelectSettings() {
            return {
                multiple: false,
                placeholder: "Choose Category",
                escapeMarkup: (markup) => markup,
                templateResult: (data) => this.categoryOptionHtml(data),
                templateSelection: (data) => this.categoryOptionHtml(data),
            };
        },
    },

    validations: {
        holidayData: {
            date: {
                required
            },
            description: {
                maxLength: maxLength(1000)
            },
        },
        holidayTypeValid: {
            typeFromConfig() {
                const value = this.holidayData.type;
                if (value === "" || value === null || value === undefined || Number(value) === 0) {
                    return true;
                }
                const n = Number(value);
                if (Number.isNaN(n)) {
                    return false;
                }
                return CONFIG.HOLIDAY_TYPE_OPTIONS[n] !== undefined;
            },
        },
        holidayCategoryValid: {
            categoryFromConfig() {
                const value = this.holidayData.category_id;
                if (value === "" || value === null || value === undefined || Number(value) === 0) {
                    return true;
                }
                const n = Number(value);
                if (Number.isNaN(n)) {
                    return false;
                }
                const opts = CONFIG.HOLIDAY_EVENT_CATEGORY_OPTIONS || [];
                return opts.some((o) => Number(o.id) === n);
            },
        },
        holidayIsDayOffValid: {
            dayOffRequiredForNonEventTypes() {
                const type = Number(this.holidayData.type);
                const isDayOff = this.holidayData.is_day_off;
                
                // For non-event types (1, 2), is_day_off must be 1 (true)
                if (type !== 3) {
                    return isDayOff === 1 || isDayOff === "1";
                }
                
                // For event type (3), no restriction - can be 0 or 1
                return true;
            }
        }
    },

    methods: {
        holidayCategorySwatchColor(colorCode) {
            if (typeof colorCode === "string" && /^#[0-9A-Fa-f]{6}$/.test(colorCode)) {
                return colorCode;
            }
            return "#94a3b8";
        },

        categoryOptionHtml(data) {
            if (!data || data.id === undefined || data.id === null || data.id === "") {
                return "";
            }
            if (Number(data.id) === 0) {
                return data.text != null ? String(data.text) : "";
            }
            const id = Number(data.id);
            const opt = (CONFIG.HOLIDAY_EVENT_CATEGORY_OPTIONS || []).find(
                (o) => Number(o.id) === id
            );
            const rawLabel =
                data.text != null && String(data.text) !== ""
                    ? String(data.text)
                    : opt && opt.label
                      ? String(opt.label)
                      : "";
            const color = this.holidayCategorySwatchColor(
                (opt && opt.color_code) || data.color_code
            );
            const escaped = rawLabel
                .replace(/&/g, "&amp;")
                .replace(/</g, "&lt;")
                .replace(/>/g, "&gt;")
                .replace(/"/g, "&quot;");
            return (
                '<span class="holiday-category-select-row" style="display:flex;align-items:center;justify-content:space-between;gap:8px;width:100%;">' +
                '<span class="holiday-category-select-row__txt" style="flex:1;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">' +
                escaped +
                "</span>" +
                '<span class="holiday-category-select-row__swatch" style="flex-shrink:0;width:14px;height:14px;border-radius:3px;background-color:' +
                color +
                ';border:1px solid rgba(0,0,0,0.15);" aria-hidden="true"></span>' +
                "</span>"
            );
        },

        syncOptionalFieldsFromHoliday() {
            const h = this.holidayData;
            const typeNum = h.type !== null && h.type !== undefined && h.type !== ""
                ? Number(h.type)
                : 0;
            h.type = Number.isNaN(typeNum) ? 0 : typeNum;
            const catNum = h.category_id !== null && h.category_id !== undefined && h.category_id !== ""
                ? Number(h.category_id)
                : 1;
            h.category_id = Number.isNaN(catNum) ? 1 : (catNum === 0 ? 1 : catNum);
            if (h.is_day_off === true || h.is_day_off === 1 || h.is_day_off === "1") {
                h.is_day_off = 1;
            } else if (h.is_day_off === false || h.is_day_off === 0 || h.is_day_off === "0") {
                h.is_day_off = 0;
            } else {
                h.is_day_off = 0;
            }
        },

        appendOptionalHolidayFields(payload) {
            const data = this.holidayData;
            if (
                data.type !== "" &&
                data.type !== null &&
                data.type !== undefined &&
                Number(data.type) !== 0
            ) {
                payload.type = Number(data.type);
            }
            const cat = data.category_id;
            if (
                cat !== "" &&
                cat !== null &&
                cat !== undefined &&
                Number(cat) !== 0
            ) {
                payload.category_id = Number(cat);
            }
            if (data.is_day_off === 1 || data.is_day_off === "1") {
                payload.is_day_off = true;
            } else if (data.is_day_off === 0 || data.is_day_off === "0") {
                payload.is_day_off = false;
            }
        },

        getHolidayType() {
            const result = [];
            Object.entries(CONFIG.HOLIDAY_TYPE_OPTIONS).forEach(([id, key]) => {
                result.push({
                    id: id,
                    text: key,
                });
            });
            this.typeArr = result;
        },

        getHolidayCategoryOptions() {
            const result = [];
            Object.entries(CONFIG.HOLIDAY_EVENT_CATEGORY_OPTIONS || []).forEach(
                ([, opt]) => {
                    result.push({
                        id: opt.id,
                        text: opt.label,
                        color_code: opt.color_code,
                    });
                }
            );
            this.categoryArr = result;
        },

        getHolidayEdit() {
            axios.get("/holiday/detail/" + this.$route.params.id)
                .then(response => {
                    this.holidayData = response.data;
                    this.syncOptionalFieldsFromHoliday();
                    this.isLoading = false;
                    if (this.holidayData?.id == null) {
                        // if no data found, print no data message
                        this.holidayData = {};
                    }
                })
                .catch(error => {
                    if (error.response && error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('login');
                    }
                    this.isLoading = false;
                    console.log("Holiday Detail API Error", error);
                });
        },

        confirmUpdate() {
            if (this.disabled) return;
            this.submitted = true;
            if (this.$v.$invalid || this.holidayData.date == '' || this.holidayData.date == 0) {
                return;
            }
            this.update();
        },

        update() {
            this.disabled = true;
            var id = this.$route.params.id
            var request = {
                campus_id: store.state.user.campus_id,
                date: this.holidayData.date,
                description: this.holidayData.description,
                updated_id: store.state.user.id,
            };
            this.appendOptionalHolidayFields(request);

            axios.post("/holiday/update/" + id, request, {
                headers: {
                    'Content-Type': 'application/json',
                }
            })
                .then(response => {
                    if (response.data.success == true) {
                        this.$notification.success("Holiday Updated Successfully", {
                            timer: 3,
                            position: "bottomCenter"
                        });
                        this.$router.push({
                            name: "holidayList"
                        });
                    } else {
                        this.disabled = false;
                        this.$notification.error(response.data.message, {
                          timer: 3,
                          position: "bottomCenter"
                        });
                    }
                })
                .catch(error => {
                    if (error.response && error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('login');
                    }
                    this.disabled = false;
                    this.isLoading = false;
                    console.log("Holiday Edit API Error", error.errors);
                });
        },

        showList() {
            this.$router.push({
                path: "/holiday/list"
            });
        },
    },
    mounted() {
        this.getHolidayType();
        this.getHolidayCategoryOptions();
        this.isLoading = true;
        this.getHolidayEdit();
    },
};
